import { useState } from 'react';
import { TRIAL_MODE_SUBSCRIPTION_REQUIRED_ERROR_MESSAGE } from '@/api/const';
import { hasResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { ResponseErrorType } from '@/types/sharedTypes';

export const useSubscriptionRequiredError = () => {
  const [hasSubscriptionRequiredError, setHasSubscriptionRequiredError] = useState(false);

  const handleSubscriptionRequiredError = (error: ResponseErrorType) => {
    const hasError = hasResponseError(error, TRIAL_MODE_SUBSCRIPTION_REQUIRED_ERROR_MESSAGE);

    if (hasError) {
      setHasSubscriptionRequiredError(true);
    }
  };

  const resetSubscriptionRequiredError = () => {
    setHasSubscriptionRequiredError(false);
  };

  return {
    hasSubscriptionRequiredError,
    resetSubscriptionRequiredError,
    handleSubscriptionRequiredError,
  };
};
